class Video {
  constructor(el) {
    this.el = el
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$mute = this.el.querySelector('.js-mute')
    this.ui.$muteIcon = this.el.querySelector('.js-mute-icon')
    this.ui.$unmuteIcon = this.el.querySelector('.js-unmute-icon')
    this.ui.$video = this.el.querySelector('.js-video')
    this.ui.$playBtn = this.el.querySelector('.js-control')
    this.ui.$playIcon = this.el.querySelector('.js-play-icon')
    this.ui.$pauseIcon = this.el.querySelector('.js-pause-icon')
    this.ui.$transcriptBtn = this.el.querySelector('.js-transcript')
    this.ui.$transcriptPopup = document.querySelector('.js-transcript-popup')
    this.ui.$transcriptClose = document.querySelector('.js-transcript-close')
    this.ui.$transcriptContent = document.querySelector('.js-transcript-content')

    this.isPlaying = false
    this.isMute = true

    if (this.ui.$video.offsetWidth > this.ui.$video.offsetHeight) {
      this.el.classList.add('landscape')
    } else {
      this.el.classList.add('portrait')
    }

    // Masquer le bouton de transcription s'il n'y a pas de description
    if (this.ui.$transcriptBtn && (!this.ui.$video.getAttribute('data-description') || this.ui.$video.getAttribute('data-description').trim() === '')) {
      this.ui.$transcriptBtn.style.display = 'none'
    }

    this.setAriaDescribedBy()
  }

  bindEvents() {
    if (this.el.classList.contains('js-card--module')) {
      this.el.addEventListener('click', this.toggle.bind(this))  
    } else {
      this.ui.$mute.addEventListener('click', this.toggle.bind(this))
    }
    this.ui.$playBtn.addEventListener('click', this.playToggle.bind(this))
    if (this.ui.$transcriptBtn && this.ui.$transcriptBtn.style.display !== 'none') {
      this.ui.$transcriptBtn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (!this.ui.$transcriptPopup.classList.contains('animate-in')) {
          this.openTranscript()
        }
      }, true)
    }
    if (this.ui.$transcriptClose) {
      this.ui.$transcriptClose.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.closeTranscript()
      }, true)
    }
  }

  playToggle() {
    if (this.isPlaying) {
      this.pause()
    } else {
      this.play()
    }
  }

  play() {
    this.ui.$video.play()
    this.isPlaying = true
    this.ui.$playIcon.classList.add('u-is-hidden')
    this.ui.$pauseIcon.classList.remove('u-is-hidden')
    this.setAriaDescribedBy()
  }

  pause() {
    this.ui.$video.pause()
    this.isPlaying = false
    this.ui.$playIcon.classList.remove('u-is-hidden')
    this.ui.$pauseIcon.classList.add('u-is-hidden')
    this.setAriaDescribedBy()
  }

  toggle(e) {
    let target = e.target.closest('.js-mute')

    if (this.isMute) {
      this.unmute(target)
    } else {
      this.mute(target)
    }
  }

  unmute() {
    this.ui.$video.muted = false
    this.isMute = false
    this.ui.$muteIcon.classList.add('u-is-hidden')
    this.ui.$unmuteIcon.classList.remove('u-is-hidden')
    this.setAriaDescribedBy()
  }

  mute() {
    this.ui.$video.muted = true
    this.isMute = true
    this.ui.$muteIcon.classList.remove('u-is-hidden')
    this.ui.$unmuteIcon.classList.add('u-is-hidden')
    this.setAriaDescribedBy()
  }

  setAriaDescribedBy() {
    this.ui.$playBtn.setAttribute('aria-describedby', this.isPlaying ? 'pause-video' : 'play-video')
    this.ui.$mute.setAttribute('aria-describedby', this.isMute ? 'mute-video' : 'unmute-video')
  }

  decodeHtmlEntities(text) {
    if (!text) return text;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  openTranscript() {
    console.log('openTranscript - début');
    
    const description = this.decodeHtmlEntities(this.ui.$video.getAttribute('data-description')) || 'Transcription non disponible.'
    
    // On préserve le h1 existant et on remplace le contenu de description
    const existingH1 = this.ui.$transcriptContent.querySelector('h1')
    const h1Html = existingH1 ? existingH1.outerHTML : ''
    
    // Chercher et remplacer ou créer le div de description
    let descriptionDiv = this.ui.$transcriptContent.querySelector('.transcript-popup__text')
    if (descriptionDiv) {
      descriptionDiv.innerHTML = description
    } else {
      descriptionDiv = document.createElement('div')
      descriptionDiv.className = 'transcript-popup__text wysiwyg body-s'
      descriptionDiv.innerHTML = description
      this.ui.$transcriptContent.appendChild(descriptionDiv)
    }
    
    // Reconstituer le HTML complet
    this.ui.$transcriptContent.innerHTML = h1Html + descriptionDiv.outerHTML
    
    this.ui.$transcriptPopup.removeAttribute('hidden')
    this.ui.$transcriptPopup.classList.remove('animate-out')
    this.ui.$transcriptPopup.classList.add('animate-in')
    this.ui.$transcriptBtn.classList.add('is-active')

    // Gérer le focus
    const allFocusableElements = document.querySelectorAll('a, button')
    allFocusableElements.forEach(el => {
      if (!el.closest('.js-transcript-popup')) {
        el.tabIndex = -1
      }
    })

    const transcriptFocusableElements = this.ui.$transcriptPopup.querySelectorAll('button')
    transcriptFocusableElements.forEach(el => {
      el.tabIndex = 0
    })

    // Gérer les événements de clavier
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        this.closeTranscript()
      }
      if (e.key === 'Tab') {
        const currentIndex = Array.from(transcriptFocusableElements).indexOf(document.activeElement)
        
        if (e.shiftKey) {
          if (currentIndex === 0) {
            e.preventDefault()
            transcriptFocusableElements[transcriptFocusableElements.length - 1].focus()
          }
        } else {
          if (currentIndex === transcriptFocusableElements.length - 1) {
            e.preventDefault()
            transcriptFocusableElements[0].focus()
          }
        }
      }
    }

    // Supprimer l'ancien gestionnaire d'événements s'il existe
    if (this._transcriptKeyDownHandler) {
      this.ui.$transcriptPopup.removeEventListener('keydown', this._transcriptKeyDownHandler)
    }

    this.ui.$transcriptPopup.addEventListener('keydown', handleKeyDown)
    this._transcriptKeyDownHandler = handleKeyDown

    // Focus sur le premier élément avec un délai pour éviter les conflits d'événements
    setTimeout(() => {
      const firstFocusableElement = this.ui.$transcriptPopup.querySelector('button')
      if (firstFocusableElement) {
        firstFocusableElement.focus()
      }
    }, 0)

    console.log('openTranscript - fin');
  }

  closeTranscript() {
    console.log('closeTranscript');
    
    this.ui.$transcriptBtn.classList.remove('is-active')
    this.ui.$transcriptPopup.classList.remove('animate-in')
    this.ui.$transcriptPopup.classList.add('animate-out')
    
    if (this._transcriptKeyDownHandler) {
      this.ui.$transcriptPopup.removeEventListener('keydown', this._transcriptKeyDownHandler)
      this._transcriptKeyDownHandler = null
    }
    
    // Restaurer le focus
    const allFocusableElements = document.querySelectorAll('a, button')
    allFocusableElements.forEach(el => {
      el.tabIndex = 0
    })

    const onTransitionEnd = () => {
      this.ui.$transcriptPopup.classList.remove('animate-out')
      this.ui.$transcriptPopup.setAttribute('hidden', '')
      this.ui.$transcriptPopup.removeEventListener('transitionend', onTransitionEnd)
    }
    this.ui.$transcriptPopup.addEventListener('transitionend', onTransitionEnd)
  }
}

export default Video
